import { useContext } from "react";

import { useMutation } from "@apollo/client";

import { SET_USER_PREFERENCE } from "../../app/graphql/mutations";
import { UserSettings } from "../../app/main/main.types";
import { ErrorManagementContext } from "../errorManagement/ErrorManagementProvider";

const useUserPreference = () => {
  const { cookClubLog } = useContext(ErrorManagementContext);

  const [updateUserSettings, { loading, error }] = useMutation(SET_USER_PREFERENCE);

  const updatingUserSettings = async (
    userId: string,
    userSettingsData: UserSettings,
    onSaveCallBack: () => void,
  ) => {
    try {
      await updateUserSettings({
        variables: { id: userId, userSettings: userSettingsData },
      });
      
      if (error) {
        cookClubLog(
          `Failed to set preference`,
          "FAILED TO UPDATE PREFERENCE",
          { userId },
          { ui: { type: "error" } },
        );
      } else {
        onSaveCallBack();
      }
    } catch (err) {
      console.error("error updating userSettings: ", err);
    }
  };

  return { updatingUserSettings, loading };
};

export default useUserPreference;

